import { Box, IconButton } from '@mui/material';
import { useModules } from '@schamburg-web/components';
import { ControlPosition, MapControl } from '@vis.gl/react-google-maps';
import React from 'react';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import SidebarDisplay from '../SidebarDisplay/SidebarDisplay';

interface SidebarControlProps {
  controlPosition: ControlPosition;
}

const SidebarControl: React.FC<SidebarControlProps> = ({ controlPosition }) => {
  const { sidebarOpen, toggleSidebar } = useModules();
  return (
    <MapControl position={controlPosition}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          position: 'relative',
          maxHeight: 'var(--map-container-height)',
          minHeight: 'var(--map-container-height)',
          height: 'var(--map-container-height)',
          maxWidth: '450px',
        }}
      >
        {sidebarOpen && (
          <Box
            sx={{
              overflow: 'visible', // Changed from 'hidden' to preserve rounded corners
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <SidebarDisplay />
          </Box>
        )}
        <Box
          className="map-control"
          sx={{
            height: 'var(--map-container-height)',
            display: 'flex',
            alignContent: 'center',
            alignItems: 'center',
            justifyContent: 'center',
            marginLeft: '-7px',
            zIndex: 1,
          }}
        >
          <IconButton
            aria-label="Open Sidebar"
            title="Open Sidebar"
            className={
              sidebarOpen
                ? 'map-control-on map-control-icon-large'
                : ' map-control-off map-control-icon-large'
            }
            onClick={() => toggleSidebar()}
            sx={{
              width: '40px',
              borderRadius: '0px 10px 10px 0px',
            }}
          >
            {sidebarOpen ? <ArrowBackIosNewIcon /> : <ArrowForwardIosIcon />}
          </IconButton>
        </Box>
      </Box>
    </MapControl>
  );
};

export default SidebarControl;
